<portal-page class="einreichung-layout" design="none">
  <portal-einreichung-stepper-with-info class="stepper-wrapper" [currentStep]="currentStep" />
  <ebeihilfe-einreichung
    class="einreichung-content"
    [hidden]="showSpinner === true"
    (stepChangeEmitter)="fromEinreichungsStepEmitter($event)"
    (antragChangedEmitter)="antragChangedEmitter($event)"
    (hasUiValueChangedEmitter)="hasUiEmitter($event)" />
  @if (showSpinner) {
    <mat-spinner class="spinner" />
  }
</portal-page>
